<div class="snackbar-content" [ngClass]="data.type" dir="rtl">
  <div class="snackbar-icon">
    <span *ngIf="data.type === 'success'">✓</span>
    <span *ngIf="data.type === 'error'">✕</span>
    <span *ngIf="data.type === 'warning'">⚠</span>
    <span *ngIf="data.type === 'info'">ℹ</span>
  </div>
  <div class="snackbar-message">{{ data.message }}</div>
  <button class="snackbar-action" (click)="snackBarRef.dismiss()">
    {{ data.action || 'إغلاق' }}
  </button>
</div>